module.exports = __webpack_public_path__ + "static/media/price.83676149.svg";